var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgG(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_113_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58172 0 0 3.35786 0 7.5C0 11.6421 3.58172 15 8 15C12.4183 15 16 11.6421 16 7.5C16 3.35786 12.4183 0 8 0ZM7.94239 3.43322C9.02273 3.43805 10.0102 4.08392 10.4297 4.98505C10.5732 5.29891 10.6494 5.62134 10.6494 5.97108V6.86281H11.96V11.5668H4.04004V6.86279H5.24512C5.2342 6.23271 5.22037 5.51191 5.45605 4.98503C5.91432 4.03616 6.86203 3.4284 7.94239 3.43322ZM7.88379 4.93103C7.28537 4.94283 6.89072 5.36944 6.83299 5.97105V6.86279H9.06152V5.96191C9.03404 5.3914 8.57347 4.94674 7.94236 4.93103C7.92284 4.93059 7.90331 4.93059 7.88379 4.93103V4.93103Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_113_33"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgG);
export default __webpack_public_path__ + "static/media/g.bd4118ddfcaf25f8fc429836cb16620a.svg";
export { ForwardRef as ReactComponent };